export default __webpack_public_path__ + "static/media/choosePersonalHr.09951d78.svg";